export default function Label({children, className, ...props})
{
  return <label className={`text-sm self-center ${className}`} htmlFor={props.for}>{children}</label>;
}
